import React, { useState, useEffect } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";

import classnames from "classnames";
import { Link } from "react-router-dom";
import { FaRegTrashAlt, FaCloudUploadAlt} from "react-icons/fa";

// import connect from redux
import { connect } from "react-redux";
import {
  setAllCategories,
  setAllMerchants,
} from "../../store/cms-actions/postActions";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Select from "react-select";
import Dropzone from "react-dropzone";
import SweetAlert from "react-bootstrap-sweetalert";
import { CardImg } from "reactstrap";
import { CircularProgress } from "@material-ui/core";
// MomentJS
import moment from "moment";
import { frxAppOptions, happeningTypeOptions, mallOptions } from "../../common/constants";
import ReactQuill from "react-quill";

const EditCarouselBannerNew = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];



  const [activeTab, setactiveTab] = useState(1);
  const [imageURL, setImageUrl] = useState();
  const [propsData, setProps] = useState(props?.history?.location?.state);
  const [campaignTracking, setCampaignTracking] = useState("");

  const [token, setToken] = useState();
  const [FRXAPP, setFrxApp] = useState(false);
  const [selectedFiles, setselectedFiles] = useState([]);
  const [selectedSection, setselectedSection] = useState();
  const [selectedFRXSection, setselectedFRXSection] = useState(
    frxAppOptions[frxAppOptions.length - 1]
  );
  const [selectedPosition, setselectedPosition] = useState(1);
  const [pocunoUrl, setPocunoUrl] = useState();
  const [selectedStatus, setselectedStatus] = useState(statusOptions[0]);
  const [neverEnding, setNeverEnding] = useState(false);
  const [success_msg, setsuccess_msg] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [errorMsgAlert, setErrorMsgAlert] = useState(false);
  const [deeplinkObj, setDeepLinkObj] = useState("");
  const [pocuno, setPocuno] = useState(false);
  const [unique, setUnique] = useState(false);
  const [bannersData, setBannersData] = useState([]);
  const [isUniqueExist, setIsUniqueExist] = useState(false);
  const [EmptyUrl, setEmptyUrl] = useState(false);
  const [externalUrl,setExternalUrl]=useState()
  const [externaLinkName,setExternalLinkName]=useState("")
  const [loader,setLoader]=useState(false)
  const [customCheck,setcustomCheck]=useState()
  const [customNavigation,setCustomNavigation]=useState()
  const [externalUrlErrorMessage,setExternalUrlErrorMessage]=useState('')
  const [selectedMall, setSelectedMall] = useState(null);
  const [selectedHappeningType, setSelectedHappeningType] = useState(null);

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
      }
    }
  }

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    handleEditChanges(deeplinkObj);
    getCarouselBanners(token);
  }, [success_msg, deeplinkObj]);

  useEffect(() => {
    console.log("Props: ", props);
    setProps(props?.history?.location?.state);
    setImageUrl(props?.location?.state?.item?.image_url);
    const status = props.location.state?.item?.item_status;
      setselectedStatus(status)

      const navigateTo = props?.location?.state?.item?.navigate_to;
      if (navigateTo) {
        try {
          const parsedNavigateTo = JSON.parse(navigateTo);
          handleEditChanges(parsedNavigateTo);
          if (parsedNavigateTo?.section === "ArticleDetail") {
            const [mallValue, happeningTypeValue, articleId] = parsedNavigateTo?.params?.data?.split('|') || [];
            const defaultMall = mallOptions?.find(option => option.label=== mallValue);
            if (defaultMall) {
              setSelectedMall(defaultMall);
            }
            const defaultHappeningType = happeningTypeOptions?.find(option => option.value === happeningTypeValue);
            if (defaultHappeningType) {
              setSelectedHappeningType(defaultHappeningType);
            }
            console.log("here is the coming article id--->", articleId);
          }
        } catch (e) {
          console.error("Error parsing navigate_to", e);
        }
      }
    if (props?.location?.state?.frxHome) {
      setselectedSection({
        value: "home",
        label: "Home",
        path: "frx-home",
        medium: "AppCarousel",
      });
      const obj = JSON.parse(props?.location?.state?.item?.navigate_to);
      setDeepLinkObj(obj);
      setCampaignTracking(obj?.params?.Link);
      handleEditChanges(obj);
    } else if (props?.location?.state?.rewards) {
      setselectedSection({
        value: "rewards",
        label: "Rewards",
        path: "rewards",
        medium: "RewardsCarousel",
      });
      console.log(
        "Rewards deeplink:  ",
        JSON.parse(props?.location?.state?.item?.navigate_to)
      );
      const obj = JSON.parse(props?.location?.state?.item?.navigate_to);
      setDeepLinkObj(obj);
      setCampaignTracking(obj?.params?.Link);
      handleEditChanges(obj);
    } else if (props?.location?.state?.makan_master) {
      setselectedSection({
        value: "makan_master",
        label: "Makan Master",
        path: "makan-master",
        medium: "MakanMasterCarousel",
      });
      const obj = JSON.parse(props?.location?.state?.item?.navigate_to);
      setDeepLinkObj(obj);
      setCampaignTracking(obj?.params?.Link);
      handleEditChanges(obj);
    }

    if (props?.location?.state?.item?.sort_order) {
      const sort_order = props?.location?.state?.item?.sort_order;
      setselectedPosition(sort_order);
    }
    if (
      props?.location?.state?.item?.unpublished_at == "null" ||
      props?.location?.state?.item?.unpublished_at == undefined
    ) {
      setNeverEnding(!neverEnding);
    }
    if (
      JSON.parse(props?.location?.state?.item?.navigate_to)?.params
        ?.pocuno_ads == true
    ) {
      let Url = JSON.parse(props?.location?.state?.item?.navigate_to)?.params
        ?.pocuno_url;
      setPocunoUrl(Url);
      setPocuno(!pocuno);
      setFrxApp(true);
    }
    if (
      JSON.parse(props?.location?.state?.item?.navigate_to)?.params
        ?.is_unique == true
    ) {
      setUnique(true);
    }
  }, []);

  const getCarouselBanners = (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/frhub?path=carousel&env=production`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        let tempData = [];
        let page = undefined;
        if (props?.location?.state?.frxHome) {
          page = "home";
        } else if (props?.location?.state?.rewards) {
          page = "rewards";
        } else if (props?.location?.state?.makan_master) {
          page = "makan_master";
        }
        if (result) {
          result?.banners?.map((item) => {
            if (item.page == page) {
              tempData = [...tempData, item];
            }
          });
          console.log("here come the temp data", tempData);
          setBannersData(tempData);
        }
      })
      .catch((error) => console.log("error", error));
  };


  const handleEditChanges = (object) => {
    if(object?.custom){
      setcustomCheck(true)
      setCustomNavigation(props?.location?.state?.item?.navigate_to)
    }else{
      setcustomCheck(false)
      if(props?.location?.state?.frxHome){
      setCustomNavigation(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"AppCarousel","link":""}}))
      }else{
      setCustomNavigation(JSON.stringify({"section":"","custom":true,"params":{"CampaignMedium":"RewardsCarousel","link":""}}))
      }

    }
    if (object?.params?.show_add_selection_modal) {
      setFrxApp(true);
      setselectedFRXSection({ label: "Add Gift Card", value: "add_gift_card" });
    } else if (object?.params?.show_buy_selection_modal) {
      setFrxApp(true);
      setselectedFRXSection({ label: "Buy Gift Card", value: "buy_gift_card" });
    } else {
      frxAppOptions?.filter((item) => {
        if (item?.value == object?.section) {
          setFrxApp(true);
          setselectedFRXSection(item);
        } else if (object?.section == "rewards") {
          setFrxApp(true);
          setselectedFRXSection(frxAppOptions[0]);
        }
      });
    }
    if(object?.url){
      setExternalUrl(object?.url)
      setExternalLinkName(object?.external_link_name)
    }
  };

  const renderSuccessAlert = () => {
    console.log("Coming in render success alert");
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push(`/carousel-banners/${selectedSection?.path}`);
        }}
        onConfirm={() => {
          props?.history.push(`/carousel-banners/${selectedSection?.path}`);
          setsuccess_msg(false);
          setLoader(false)
        }}
        onCancel={() => {
          setsuccess_msg(false);
        }}
      >
        {"Carousel banner updated successfully."}
      </SweetAlert>
    );
  };
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false);
          setLoader(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };
  async function handleSubmit() {
    if (isUniqueExist) {
      toggleTab(1);
      return;
    } else if (
      selectedSection?.value == "home" ||
      selectedSection?.value == "rewards"
    ) {
      if (pocuno) {
        if (!pocunoUrl) {
          SetErrorMessage("Please Enter Url")
          setErrorMsgAlert(true)
          toggleTab(1)
          return;
        }
      }
    }

    const title = document.getElementById("title_input")?.value
      ? document.getElementById("title_input")?.value
      : "";
    const description = document.getElementById("description_input")?.value
      ? document.getElementById("description_input")?.value
      : "";
    const link = campaignTracking
      ? campaignTracking
      : document.getElementById("campaign_link_input")?.value
      ? document.getElementById("campaign_link_input")?.value
      : "";
    const section = selectedSection ? selectedSection.value : "";
    const articleId = document.getElementById("article_id")?.value;
    const titleFRX = document.getElementById("title_input_frx")?.value;
    const position = selectedPosition ? selectedPosition : "";
    let publishAt = moment(
      document.getElementById("publishAt_input")?.value
    )?.format("YYYY/MM/DD HH:mm");
    let unpublishAt = moment(
      document.getElementById("unpublishAt_input")?.value
    )?.format("YYYY/MM/DD HH:mm");
    let currentDate = moment(new Date()).format("YYYY/MM/DD HH:mm");
    currentDate = currentDate.toString();
    if (publishAt == "Invalid date") {
      publishAt = currentDate;
    }


   if(!pocuno){ 
    if(!selectedPosition){
      SetErrorMessage("Please Enter Position")
      setErrorMsgAlert(true)
      toggleTab(1)
      return
    }
   else if(!title){
      SetErrorMessage("Please Enter Title")
      setErrorMsgAlert(true)
      toggleTab(1)
      return
    }else if(!description){
      SetErrorMessage("Please Enter Description")
      setErrorMsgAlert(true)
      toggleTab(1)
      return
    }else if (!imageURL) {
      if (selectedFiles.length < 1) {
        SetErrorMessage("Please select image");
        setErrorMsgAlert(true);
        toggleTab(1)
        return;
      }
    }
}

    if (!neverEnding) {
    if(unpublishAt == "Invalid date"){
    SetErrorMessage("Please select unpublish date")
    setErrorMsgAlert(true)
    toggleTab(1)
    return }    
    else if(unpublishAt < publishAt){
      SetErrorMessage("Unpublish date should be after the publish date")
      setErrorMsgAlert(true)
      toggleTab(1)
      return
      }
  }  else if(customCheck){
    if(!customNavigation){
      SetErrorMessage("Please Enter Navigation")
      setErrorMsgAlert(true)
      return
    }
}

    if(selectedFRXSection.value == "NA"){
      if(!externalUrl){
        SetErrorMessage("Please Enter URL")
        setErrorMsgAlert(true)
        return
      }else if(externalUrlErrorMessage){
        SetErrorMessage("Please enter valid URL")
        setErrorMsgAlert(true)
        return
      }else if(!checkTextInsideHtml(externaLinkName)){
        SetErrorMessage("Please Enter Exit Message Description")
        setErrorMsgAlert(true)
        return
      }
    }



    if(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck){
      if(!link){
        SetErrorMessage("Please Enter campaign tracking name")
        setErrorMsgAlert(true)
        return
      }
    }


    setLoader(true)
    let _deeplinkObjFRX = {
      section: "",
      params: {},
    };

    if (unique) {
      _deeplinkObjFRX.params.is_unique = true;
    } else {
      _deeplinkObjFRX.params.is_unique = false;
    }

    // return
   if(!customCheck){ 
    
    if (FRXAPP) {
      if(pocuno){
        _deeplinkObjFRX.params.pocuno_ads=true
        if(selectedSection?.value=='home' || selectedSection?.value=='rewards'){
          _deeplinkObjFRX.params.pocuno_url= pocunoUrl
        }        
        _deeplinkObjFRX.section ="NA"
        _deeplinkObjFRX.params.CampaignMedium ="NA"
        _deeplinkObjFRX.params.link ="NA"
      }else{
         console.log("Selected section:  ", selectedFRXSection)
      if (selectedFRXSection) {
        _deeplinkObjFRX.section = selectedFRXSection.value
        _deeplinkObjFRX.params.CampaignMedium = selectedSection?.medium
        _deeplinkObjFRX.params.link = link

       if (selectedFRXSection.value == "ewallet") {
          // _deeplinkObjFRX.params = selectedFRXSection.params
          _deeplinkObjFRX.params.CampaignMedium = selectedSection?.medium
          _deeplinkObjFRX.params.link = link
        }else if (selectedFRXSection.value == "NA") {
          _deeplinkObjFRX={}
          _deeplinkObjFRX.section = "NA";
          _deeplinkObjFRX.url=externalUrl;
          _deeplinkObjFRX.external_link_name=externaLinkName;
        }else if (selectedFRXSection.value == "UobUni") {
          _deeplinkObjFRX.section = "UobUni";
        }else if (selectedFRXSection.value == "ShowQR") {
          _deeplinkObjFRX.section = "ShowQR";
        }else if (selectedFRXSection.value == "digital_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params._params ="digital_gift_card_listing";
        }else if(selectedFRXSection?.value == "FRxMemberSpending"){
          _deeplinkObjFRX.login_required = true
        }
        else if (selectedFRXSection.value == "add_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params.show_add_selection_modal = true;
        }else if (selectedFRXSection.value == "buy_gift_card") {
          _deeplinkObjFRX.section = "digital_gift_card";
          _deeplinkObjFRX.params.show_buy_selection_modal = true;
        }
        else if (selectedFRXSection.value == "ArticleDetail") {
          _deeplinkObjFRX.params.data = `${selectedMall?.label}|${selectedHappeningType?.value}|${articleId}`;
          _deeplinkObjFRX.params.title = titleFRX;
          _deeplinkObjFRX.params.article = { 
            category: titleFRX, 
            id: `${selectedMall?.label}|${selectedHappeningType?.value}|${articleId}` 
          };
        }
        else if (selectedFRXSection.value == "RewardsTab") {
          _deeplinkObjFRX.params.link = link
        }else if(selectedFRXSection?.label=="No Navigation"){
          _deeplinkObjFRX.section = ""
          _deeplinkObjFRX.params={}
          _deeplinkObjFRX.params.CampaignMedium = ""
          _deeplinkObjFRX.params.link =""
        }else if (selectedFRXSection.value == "BuyForMySelf") {
          _deeplinkObjFRX.params.buy_for="me"
         }
      }
    }
    }}
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("path", "carousel/update");
    formdata.append("env", "staging");
    if (selectedFiles?.length > 0) {
      formdata.append("userfile", selectedFiles[0], selectedFiles[0].path);
    }
    if (pocuno) {
      let response = await fetch(
        "https://frxassets.tgate.sg/icons/Pocuno-Default.jpg"
      );
      let data = await response.blob();
      console.log("data", data);
      let file = new File([data], "download.jpg");
      formdata.append("userfile", file, "download.jpg");
    }

    formdata.append("description", pocuno ? "NA" : description);
    formdata.append("title", pocuno ? "NA" : title);
    formdata.append("app_version", 1.5);
    formdata.append("item_status",selectedStatus);
    formdata.append("item_id", propsData?.item?.item_id);
    formdata.append("item_type", '"carousel_banner"');
    formdata.append(
      "item_version",18);
    formdata.append(
      "navigate_to",
      customCheck ? customNavigation : _deeplinkObjFRX
        ? JSON.stringify(_deeplinkObjFRX)
        : propsData?.item?.navigate_to
    );
    formdata.append("page", selectedSection ? selectedSection.value : section);
    formdata.append(
      "published_at",
      publishAt ? publishAt : propsData?.item?.publishAt
    );
    formdata.append("unpublished_at" , neverEnding ? null : unpublishAt );
    formdata.append("slider_delay", "0");
    formdata.append(
      "sort_order",
      position ? position : propsData?.item?.sort_order
    );

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      processData: false,
      mimeType: "multipart/form-data",
      async: true,
      crossDomain: true,
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/frhub`, requestOptions)
      .then((response) => {
        if (response.status == 200) {
          setsuccess_msg(true);
          setLoader(false)
        } else {
          SetErrorMessage("Unable to Add Carousel Banner");
          setErrorMsgAlert(true);
          setLoader(false)
        }
        response.json();
      })
      .catch((error) =>{ 
        console.log("error", error)
        SetErrorMessage("Unable to Add Carousel Banner");
        setErrorMsgAlert(true);
        setLoader(false)
      });
  }


  const checkCharacterCount = (e, count) => {
    if (e.target.innerText.length > count && e.key !== 'Backspace') {
      e.preventDefault()
    }
  }
  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };
  const validateFileSize = (file) => {
    var reader = new FileReader();

    //Read the contents of Image File.
    reader.readAsDataURL(file[0]);
    reader.onloadend = function (e) {
      //Initiate the JavaScript Image object.
      var image = new Image();

      //Set the Base64 string return from FileReader as source.
      image.src = e.target.result;
      //Validate the File Height and Width.
      image.onload = function () {
        var height = this.height;
        var width = this.width;
        if (width !== 600 || height !== 320) {
          SetErrorMessage("Height and Width must be 600x320px");
          setErrorMsgAlert(true);
          // return false;
        }else{
          handleAcceptedFiles(file);
        }
      };
    };
  };
  function handleAcceptedFiles(files) {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    );
    let path = files[0].path;
    path = path.split(".");
    path = path[1];
    if (path == "jpg"  || path == "JPG") {
      setselectedFiles(files);
      setImageUrl("")
    } else {
      SetErrorMessage("Please select a .jpg file");
      setErrorMsgAlert(true);
    }
  }
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }

  const handleExternalUrl = (value) =>{
    setExternalUrl(value)
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if(value){
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage("Please enter valid URL (Including https://)")
      } else {
        setExternalUrlErrorMessage("");
      }
    }else{
      setExternalUrlErrorMessage("");
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="Carousel Banners"
            breadcrumbItem="Add Carousel Banner"
          />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <h4 className="card-title mb-4">Basic Wizard</h4> */}
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1);
                            }}
                          >
                            <span className="number">1.</span> Edit Carousel
                            Banner
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2);
                            }}
                          >
                            <span className="number">2.</span> {"Navigation"}
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>
                    <div className="content clearfix">
                      <div className="body">
                        <TabContent activeTab={activeTab}>
                          <TabPane tabId={1}>
                            <Form>
                              <Row></Row>
                            </Form>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={12} md={12} sm={12}>
                                        <div className="mt-5 mt-lg-4">
                                          <Form
                                            className=""
                                            method="post"
                                            id="tooltipForm"
                                          >
                                            <div>
                                              <Row>
                                                <Col lg={4} md={6} sm={6}>
                                                  <div
                                                    className={
                                                      isUniqueExist
                                                        ? ""
                                                        : "mb-4"
                                                    }
                                                  >
                                                    <Label>Position</Label>
                                                    <input
                                                      className="form-control"
                                                      type="text"
                                                      onKeyPress={(event) => {
                                                        if (
                                                          !/[0-9]/.test(
                                                            event.key
                                                          )
                                                        ) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      id="position_input"
                                                      onChange={(e) => {
                                                        console.log(
                                                          "Position is: ",
                                                          e
                                                        );
                                                        setselectedPosition(
                                                          e.target.value
                                                        );
                                                      }}
                                                      defaultValue={
                                                        propsData?.item
                                                          ?.sort_order
                                                          ? propsData?.item
                                                              ?.sort_order
                                                          : 1
                                                      }
                                                    />
                                                  </div>
                                                  {isUniqueExist && (
                                                    <div
                                                      style={{
                                                        color: "red",
                                                        fontSize: 12,
                                                      }}
                                                    >
                                                      position is unique! please
                                                      choose another position
                                                    </div>
                                                  )}
                                                </Col>
                                                <Col md={1}></Col>
                                              </Row>
                                              {selectedSection?.value ==
                                                "home" &&
                                                pocuno && (
                                                  <Row>
                                                    <Col lg={4} md={6} sm={6}>
                                                      <div className="mb-4">
                                                        <Label>Url</Label>
                                                        <input
                                                          onChange={(e) => {
                                                            setPocunoUrl(
                                                              e.target.value
                                                            );
                                                            setEmptyUrl(false);
                                                          }}
                                                          className="form-control"
                                                          type="text"
                                                          id="url_input"
                                                          value={pocunoUrl}
                                                          min={1}
                                                        />
                                                      </div>
                                                      {EmptyUrl && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                            fontSize: 12,
                                                            marginTop: "-20px",
                                                          }}
                                                        >
                                                          Please Enter Url
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                )}
                                              {selectedSection?.value ==
                                                "rewards" &&
                                                pocuno && (
                                                  <Row>
                                                    <Col lg={4} md={6} sm={6}>
                                                      <div className="mb-4">
                                                        <Label>Url</Label>
                                                        <input
                                                          onChange={(e) => {
                                                            setPocunoUrl(
                                                              e.target.value
                                                            );
                                                            setEmptyUrl(false);
                                                          }}
                                                          className="form-control"
                                                          type="text"
                                                          id="url_input"
                                                          value={pocunoUrl}
                                                          min={1}
                                                        />
                                                      </div>
                                                      {EmptyUrl && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                            fontSize: 12,
                                                            marginTop: "-20px",
                                                          }}
                                                        >
                                                          Please Enter Url
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                )}
                                            </div>
                                          </Form>
                                        </div>
                                      </Col>
                                    </Row>
                                    {!pocuno && (
                                      <>
                                        <Row>
                                          <Col lg={4} md={6} sm={6}>
                                            <div className="mb-3">
                                              <Label>Title</Label>
                                              <div className="col-md-12">
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  defaultValue={
                                                    pocuno
                                                      ? ""
                                                      : propsData?.item?.title
                                                  }
                                                  id="title_input"
                                                  disabled={pocuno}
                                                  maxLength="51"
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row>
                                          <Col lg={4} md={6} sm={6}>
                                            <div className="mb-3">
                                              <Label>Description</Label>
                                              <div className="col-md-12">
                                                <input
                                                  className="form-control"
                                                  type="text"
                                                  defaultValue={
                                                    pocuno
                                                      ? ""
                                                      : propsData?.item
                                                          ?.description
                                                  }
                                                  id="description_input"
                                                  disabled={pocuno}
                                                  maxLength="60"
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </>
                                    )}
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody
                                    style={{ display: pocuno ? "none" : "" }}
                                    disabled={pocuno}
                                  >
                                    <Form>
                                      {imageURL && (
                                        <Row>
                                          <Col lg={4}>
                                            <CardImg
                                              className="img-fluid"
                                              src={imageURL}
                                              style={{
                                                marginBottom: 15,
                                                width: "500px",
                                              }}
                                              alt=""
                                            />
                                          </Col>
                                          <Col>
                                            <div
                                              className="px-3 text-danger"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                setImageUrl("");
                                              }}
                                            >
                                              <FaRegTrashAlt />
                                              Move To Trash
                                            </div>
                                          </Col>
                                        </Row>
                                      )}
                                      <Dropzone
                                        onDrop={(acceptedFiles) => {
                                          validateFileSize(acceptedFiles);
                                        }}
                                        disabled={pocuno}
                                      >
                                        {({ getRootProps, getInputProps }) => (
                                          <div
                                            className="dropzone"
                                            style={{
                                              background: pocuno
                                                ? "#F5F6F8"
                                                : "",
                                            }}
                                          >
                                            <div
                                              className="dz-message needsclick"
                                              {...getRootProps()}
                                            >
                                              <input {...getInputProps()} />
                                              <div className="mb-3">
                                                <FaCloudUploadAlt className="display-4 text-muted"/>
                                              </div>
                                              <h4>
                                                Drop files here or click to
                                                upload.
                                              </h4>
                                              {!pocuno && (
                                                <p
                                                  style={{
                                                    fontSize: 12,
                                                    color: "red",
                                                    marginBottom: 0,
                                                  }}
                                                >{`Image should be 600x320px in jpg`}</p>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </Dropzone>
                                      <div
                                        className="dropzone-previews mt-3"
                                        id="file-previews"
                                      >
                                        {selectedFiles.map((f, i) => {
                                          return (
                                            <Card
                                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                              key={i + "-file"}
                                            >
                                              <div className="p-2">
                                                <Row className="align-items-center">
                                                  <Col className="col-auto">
                                                    <img
                                                      data-dz-thumbnail=""
                                                      height="80"
                                                      className="avatar-sm rounded bg-light"
                                                      alt={f.name}
                                                      src={f.preview}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    <Link
                                                      to="#"
                                                      className="text-muted font-weight-bold"
                                                    >
                                                      {f.name}
                                                    </Link>
                                                    <p className="mb-0">
                                                      <strong>
                                                        {f.formattedSize}
                                                      </strong>
                                                    </p>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </Card>
                                          );
                                        })}
                                      </div>
                                    </Form>

                                    {/* <div className="text-center mt-4">
                    <button
                      type="button"
                      className="btn btn-primary waves-effect waves-light"
                    >
                      Send Files
                    </button>
                  </div> */}
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Publish At</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="datetime-local"
                                              id="publishAt_input"
                                              placeholder="dd/mm/yyyy"
                                              defaultValue={
                                                propsData?.item?.published_at
                                                  ? moment(
                                                      propsData?.item
                                                        ?.published_at
                                                    ).format("YYYY-MM-DDTHH:mm")
                                                  : ""
                                              }
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col lg={1}></Col>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Unpublish At</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="datetime-local"
                                              id="unpublishAt_input"
                                              placeholder="dd/mm/yyyy"
                                              disabled={neverEnding}
                                              defaultValue={
                                                propsData?.item?.unpublished_at
                                                  ? moment(
                                                      propsData?.item
                                                        ?.unpublished_at
                                                    ).format("YYYY-MM-DDTHH:mm")
                                                  : ""
                                              }
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <Col style={{ paddingTop: 35 }}>
                                        <div className="form-check form-switch">
                                          <input
                                            type="checkbox"
                                            className="form-check-input checkbox"
                                            id="checkbox_1"
                                            checked={neverEnding}
                                            // defaultChecked={propsData?.item?.unpublished_at == "null" ? true : neverEnding}
                                            onChange={() =>
                                              setNeverEnding(!neverEnding)
                                            }
                                          />

                                          <label
                                            className="form-check-label"
                                            htmlFor="checkbox_1"
                                          >
                                            Never-ending
                                          </label>
                                        </div>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Status</Label>
                                          <Select
                                            isSearchable={true}
                                            value={selectedStatus}
                                            onChange={(e) => {
                                              setselectedStatus(e.value);
                                            }}
                                            options={statusOptions}
                                            placeholder={
                                              selectedStatus
                                              ? selectedStatus == "Y"
                                                ? "Enable"
                                                : "Disable"
                                              : "Choose..."
                                            }
                                            defaultValue={
                                              selectedStatus
                                            }
                                            required
                                          />
                                        </div>
                                      </Col>
                                      {/* <Col lg={1}></Col>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Version</Label>
                                          <div className="col-md-12">
                                            <input
                                              className="form-control"
                                              type="text"
                                              id="version_input"
                                              defaultValue={
                                                propsData?.item?.item_version
                                                  ? propsData?.item
                                                      ?.item_version
                                                  : 18
                                              }
                                            />
                                            <small className="text-muted user-select-none">
                                              For mobile app only
                                            </small>
                                          </div>
                                        </div>
                                      </Col> */}
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Form>
                                <Row>
                                  <Col lg={4} md={10} sm={10}>
                                    <div className="mb-3">
                                      <Label>Navigate To</Label>
                                      {customCheck ? 
                                        <textarea
                                        rows={4}
                                        col={20}
                                        type="text"
                                        className="form-control"
                                        id="item_group_input"
                                        onChange={(e) => {
                                          setCustomNavigation(e.target.value);
                                        }}
                                        defaultValue={customNavigation}
                                      />
                                      :<Select
                                        isSearchable={true}
                                        // value={selectedFRXSection?.label ? selectedFRXSection?.label : frxAppOptions[0].label}
                                        onChange={(e) => {
                                          setselectedFRXSection(e);
                                          setFrxApp(true);
                                        }}
                                        placeholder={
                                          selectedFRXSection?.label
                                            ? selectedFRXSection?.label
                                            : "Choose section..."
                                        }
                                        defaultValue={
                                          selectedFRXSection
                                            ? selectedFRXSection?.label
                                            : frxAppOptions[0]
                                        }
                                        options={frxAppOptions}
                                        maxMenuHeight={120}
                                        menuPlacement="auto"
                                        required
                                        isDisabled={pocuno}
                                      />}
                                    </div>
                                  </Col>
                                  <Col md={1}></Col>
                                  {!pocuno && <Col md={2} style={{paddingTop:"38px"}}>
                                  <div className="form-check form-switch">
                                    <input
                                      type="checkbox"
                                      className="form-check-input checkbox"
                                      id="checkbox_custom_nav"
                                      value={customCheck}
                                      defaultChecked={customCheck}
                                      onClick={() => { 
                                      setcustomCheck(!customCheck)
                                      }}
                                    />

                                    <label className="form-check-label" htmlFor="checkbox_pocuno">
                                      Custom Navigation
                                    </label>
                                  </div>
                                  </Col>}
                                </Row>
                                <Row>
                                { (selectedFRXSection?.label == "External Link" && !customCheck) &&
                                  <Col lg={4} md={6} sm={6}>
                                    <div className="mb-3">
                                      <Label>URL*</Label>
                                      <input
                                        className="form-control"
                                        type="text"
                                        defaultValue={externalUrl}
                                        disabled={pocuno}
                                        id="campaign_link_input"
                                        onChange={(e) => {setFrxApp(true)
                                        handleExternalUrl(e.target.value)}}
                                      />
                                      {externalUrlErrorMessage && (
                                      <p style={{ color: "red", fontSize: 12 }}>
                                        {externalUrlErrorMessage}
                                      </p>
                                    )}
                                    </div>
                                  </Col>}
                                </Row>
                                <Row>
                              {(selectedFRXSection?.label == "External Link" && !customCheck)&&
                              <Col lg={4} md={6} sm={6}>
                                <div className="mb-3">
                                  <Label>{"Exit Message Description*"}</Label>
                                  <ReactQuill
                                    modules={{
                                      toolbar: [
                                        ["bold", "italic", "underline"],
                                        [{ list: "ordered" }, { list: "bullet" }],
                                        ["link", { color: [] }],
                                        ["clean"],
                                      ],
                                    }}
                                    theme="snow"
                                    value={externaLinkName}
                                    onChange={(e, delta, source, c) => {
                                      if (c.getText().length <= 2000) {
                                        setExternalLinkName(e);
                                      } else if (c.getText().length > 2000) {
                                        const remainingCharacters = 2000 - c.getText().length;
                                        let truncatedText = c.getText().slice(0, remainingCharacters);
                                        setExternalLinkName(truncatedText)
                                      }
                                    }}
                                    onKeyDown={(e) => checkCharacterCount(e, 2000)}
                                    style={{ minHeight: "30px" }}
                                  />
                                </div>
                              </Col>}
                            <Col md={1}></Col>
                           </Row>
                              {(selectedFRXSection?.value == "ArticleDetail" && !customCheck) && (
                                <>
                                  <Row>
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>Mall</Label>
                                        <Select
                                          isSearchable={true}
                                          onChange={(e) => {
                                            setSelectedMall(e);
                                            setSelectedHappeningType(null);
                                          }}
                                          options={mallOptions}
                                          placeholder="Select Mall..."
                                          value={selectedMall}
                                        />
                                      </div>
                                    </Col>
                                  </Row>
                                  
                                  {selectedMall && (
                                    <Row>
                                      <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                          <Label>Type</Label>
                                          <Select
                                            isSearchable={true}
                                            onChange={(e) => {
                                              setSelectedHappeningType(e);
                                            }}
                                            options={happeningTypeOptions}
                                            placeholder="Select Happening Type..."
                                            value={selectedHappeningType}
                                          />
                                        </div>
                                      </Col>
                                    </Row>
                                  )}
                                  
                                  {selectedHappeningType && (
                                    <>
                                      <Row>
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                         <Label>Blog ID</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={
                                            deeplinkObj?.params?.data?.split('|')[2] || '' // Extract article ID from params.
                                          }
                                            id="article_id"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                      <Row >
                                        <Col lg={4} md={6} sm={6}>
                                        <div className="mb-3">
                                        <Label>Header Title</Label>
                                          <input
                                            className="form-control"
                                            type="text"
                                            defaultValue={
                                            deeplinkObj?.params?.title
                                          }
                                            id="title_input_frx"
                                          />
                                        </div>
                                        </Col>
                                      </Row>
                                    </>
                                  )}
                                </>
                              )}
                              <Row>
                                  {(selectedFRXSection?.label != "No Navigation" && selectedFRXSection?.label != "External Link" && !customCheck) && (
                                    <Col lg={4} md={6} sm={6}>
                                      <div className="mb-3">
                                        <Label>Campaign Tracking Name</Label>
                                        {console.log(
                                          "Check campaign tracking:  ",
                                          campaignTracking
                                        )}
                                        <input
                                          disabled={pocuno}
                                          className="form-control"
                                          type="text"
                                          id="campaign_link_input"
                                          onChange={(e) =>
                                            setCampaignTracking(e.target.value)
                                          }
                                          defaultValue={
                                            campaignTracking
                                              ? campaignTracking
                                              : props?.location?.state?.item
                                                  ?.navigate_to
                                              ? JSON.parse(
                                                  props?.location?.state?.item
                                                    ?.navigate_to
                                                )?.params?.link
                                              : ""
                                          }
                                        />
                                      </div>
                                    </Col>
                                  )}
                                </Row>
                              </Form>
                            </div>
                          </TabPane>
                        </TabContent>
                      </div>
                    </div>
                    <div className="actions clearfix">
                      <ul>
                        <li className={"next"}>
                          <Link
                            to={`/carousel-banners/${selectedSection?.path}`}
                            className="btn bg-danger"
                          >
                            <i className="uil uil-times me-1"></i>Cancel
                          </Link>
                        </li>
                        <li
                          className={
                            activeTab === 1 ? "previous hidden" : "previous"
                          }
                        >
                          <Link
                            to="#"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab(activeTab - 1);
                            }}
                          >
                            Previous
                          </Link>
                        </li>
                        <li
                          className={activeTab === 4 ? "next disabled" : "next"}
                        >
                          <button
                          disabled={loader}
                          style={{color:"#ffffff", width:"80px"}}
                            className={
                              activeTab > 1
                                ? "btn bg-success"
                                : "btn btn-primary"
                            }
                            onClick={() => {
                              if (activeTab === 2) {
                                handleSubmit();
                                return;
                              } else {
                                toggleTab(activeTab + 1);
                              }
                            }}
                          >
                            {activeTab === 2 ? loader ? <CircularProgress 
                                size={15}
                                value={100}
                                color={"white"} />
                              : "Save" : "Next"}
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {success_msg ? renderSuccessAlert() : null}
          {errorMsgAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { allCategories, allMerchants } = state.rootReducers1;
  console.log("Checking redux state", state);
  return { allCategories, allMerchants };
};

const actions = {
  setAllCategories,
  setAllMerchants,
};

export default connect(mapStateToProps, actions)(EditCarouselBannerNew);
